let billing_contacts_table = require( './manage-billing-contacts-table' ),
	disable_form_button    = require( './disabled-form-button' );

let practice_setup_billing_contacts = function( $ ) {

	let $wrapper,
		$form_wrapper,
		anim_speed = 400;

	let _init = function() {
		$wrapper      = $( '#setup-practice-contacts-wrapper' );
		$form_wrapper = $( '.add-billing-contact-form-wrapper' );

		if ( $wrapper.length > 0 ) {
			_setup_clear_form();
			_setup_form_toggles();
			_setup_form();

			$( '#manage-billing-contacts-table' ).on( 'updated_table_html', ( e ) => {
				_setup_form_toggles();
			} );
		}
	};

	let _setup_form = function() {
		let $form = $form_wrapper.find( 'form' );

		disable_form_button.setup_form( $form );

		$form.on( 'submit_success', ( response ) => {
			billing_contacts_table.update_table_html();

			_close_form();

			setTimeout( () => {
				_clear_form();
			}, anim_speed );
		} );
	};

	let _setup_form_toggles = function() {
		$wrapper.find( '.toggle-form' ).off( 'click' );
		$wrapper.find( '.open-add-form, .add-billing-contact-link' ).off( 'click' );
		$wrapper.find( '.close-open-form' ).off( 'click' );

		$wrapper.find( '.toggle-form' ).on( 'click', ( e ) => {
			e.preventDefault();

			_toggle_form();
		} );

		$wrapper.find( '.open-add-form, .add-billing-contact-link' ).on( 'click', ( e ) => {
			e.preventDefault();

			_open_form();
		} );

		$wrapper.find( '.close-open-form' ).on( 'click', ( e ) => {
			e.preventDefault();

			_close_form()
		} )
	};

	let _toggle_form = function() {
		if ( $form_wrapper.hasClass( 'animating' ) ) {
			return;
		}

		$form_wrapper.addClass( 'animating' );

		if ( $form_wrapper.hasClass( 'open' ) ) {
			_close_form();
		} else {
			_open_form();
		}

		setTimeout( () => {
			$form_wrapper.removeClass( 'animating' );
		}, anim_speed );
	};

	let _close_form = function() {
		$form_wrapper.slideUp( anim_speed );
		$form_wrapper.removeClass( 'open' );
		$form_wrapper.addClass( 'closed' );
		$wrapper.removeClass( 'open-form' );
	};

	let _open_form = function() {
		$form_wrapper.slideDown( anim_speed );
		$form_wrapper.removeClass( 'closed' );
		$form_wrapper.addClass( 'open' );
		$wrapper.addClass( 'open-form' );
	};

	let _setup_clear_form = function() {
		$( '.cancel-add-billing-contact' ).on( 'click', function( e ) {
			e.preventDefault();

			_close_form();

			setTimeout( () => {
				_clear_form();
			}, anim_speed )
		} );
	};

	let _clear_form = function() {
		$form_wrapper.find( 'input' ).not( '.submit-button' ).val( '' );
		$form_wrapper.find( 'input.submit-button' ).addClass( 'disabled' );
		$form_wrapper.find( '.form-notices' ).removeClass( 'has-notices' ).html( '' );
		$form_wrapper.find( '.form-notices' ).removeClass( 'has-notices' ).html( '' );
	};

	$( document ).ready( _init );

} ( jQuery );

module.exports = practice_setup_billing_contacts;